import { useRenderGuard } from 'apprise-frontend-core/utils/renderguard'
import { PropsWithChildren } from 'react'
import { useTenantStore } from './store'


export type TenantLoaderProps = PropsWithChildren



export const TenantLoader = (props: TenantLoaderProps) => {

    const { children } = props

    const store = useTenantStore()
    
    const { content } = useRenderGuard({

        render: children,
        orRun: store.fetchAll
    })

    return content
}

